// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function agreed_doc_encode(v) {
  return Js_dict.fromArray([
              [
                "doc_type",
                Decco.stringToJson(v.doc_type)
              ],
              [
                "doc_url",
                Decco.stringToJson(v.doc_url)
              ],
              [
                "created_at",
                Decco.stringToJson(v.created_at)
              ],
              [
                "updated_at",
                Decco.stringToJson(v.updated_at)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "mobile",
                Decco.stringToJson(v.mobile)
              ],
              [
                "email",
                Decco.optionToJson(Decco.stringToJson, v.email)
              ],
              [
                "otp",
                Decco.stringToJson(v.otp)
              ],
              [
                "first_name",
                Decco.optionToJson(Decco.stringToJson, v.first_name)
              ],
              [
                "last_name",
                Decco.optionToJson(Decco.stringToJson, v.last_name)
              ],
              [
                "whatsapp_consent",
                Decco.optionToJson(Decco.boolToJson, v.whatsapp_consent)
              ],
              [
                "customer_frequency",
                Decco.optionToJson(Decco.stringToJson, v.customer_frequency)
              ],
              [
                "created_by",
                Decco.stringToJson(v.created_by)
              ],
              [
                "agreed_docs",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(agreed_doc_encode, param);
                      }), v.agreed_docs)
              ],
              [
                "referral_code",
                Decco.optionToJson(Decco.stringToJson, v.referral_code)
              ],
              [
                "geo_region_id",
                Decco.optionToJson(Decco.stringToJson, v.geo_region_id)
              ]
            ]);
}

export {
  agreed_doc_encode ,
  t_encode ,
}
/* No side effect */
